/* EUREKA · Galería de producto: muestra solo las fotos del color seleccionado */
(function () {
  function detectColor(m, colors, variantColor) {
    if (variantColor) return variantColor;
    var lc = colors.map(function (c) { return c.toLowerCase(); });
    var alt = (m.alt || '').toLowerCase();
    var i;
    if (alt) for (i = 0; i < lc.length; i++) if (alt.indexOf(lc[i]) !== -1) return colors[i];
    var name = (m.file || '').toLowerCase().replace(/\.[a-z0-9]+$/, '').replace(/_[0-9a-f]{8}-[0-9a-f-]{27}$/, '');
    for (i = 0; i < lc.length; i++) {
      var stem = lc[i].slice(0, 4);
      if (stem.length >= 4 && name.indexOf(stem) !== -1) return colors[i];
    }
    var letters = [];
    name.split(/[_\-]/).forEach(function (t) { if (t.length === 1) letters.push(t); });
    var rm = name.match(/(?:camiseta|sudadera|hoodie|polo)([a-z])(?=_|-|reverso|anverso|frente|espalda|$)/);
    if (rm) letters.push(rm[1]);
    var am = name.match(/_([a-z])(?:anverso|reverso)/);
    if (am) letters.push(am[1]);
    for (var k = 0; k < letters.length; k++) {
      var hits = [];
      lc.forEach(function (c, idx) { if (c.charAt(0) === letters[k]) hits.push(idx); });
      if (hits.length === 1) return colors[hits[0]];
    }
    return null;
  }

  function init(dataEl) {
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!data.colors || data.colors.length < 2) return;
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    var variantColor = {}; // media id -> color (por variante)
    var colorByVariant = {};
    data.variants.forEach(function (v) {
      colorByVariant[v.id] = v.color;
      if (v.media) variantColor[v.media] = v.color;
    });
    var colorOfMedia = {};
    data.media.forEach(function (m) { colorOfMedia[m.id] = detectColor(m, data.colors, variantColor[m.id]); });

    function currentColor() {
      var input = document.querySelector('product-info input[name="id"], form[action*="/cart/add"] input[name="id"]');
      var id = input ? parseInt(input.value, 10) : null;
      return id && colorByVariant[id] ? colorByVariant[id] : null;
    }

    function mediaIdOf(attr) { return (attr || '').split('-').pop(); }

    function apply() {
      var color = currentColor();
      if (!color) return;
      var viewerItems = gallery.querySelectorAll('[id^="GalleryViewer"] li[data-media-id]');
      var thumbItems = gallery.querySelectorAll('[id^="GalleryThumbnails"] li[data-target]');
      var visible = 0;
      viewerItems.forEach(function (li) {
        var c = colorOfMedia[mediaIdOf(li.dataset.mediaId)];
        var hide = !!c && c !== color;
        li.classList.toggle('eureka-hide', hide);
        if (!hide) visible++;
      });
      thumbItems.forEach(function (li) {
        var c = colorOfMedia[mediaIdOf(li.dataset.target)];
        li.classList.toggle('eureka-hide', !!c && c !== color);
      });
      var total = gallery.querySelector('.slider-counter--total');
      if (total) total.textContent = visible;
      // asegurar que hay una imagen activa visible
      var active = gallery.querySelector('[id^="GalleryViewer"] li.is-active:not(.eureka-hide)');
      if (!active) {
        var first = gallery.querySelector('[id^="GalleryViewer"] li[data-media-id]:not(.eureka-hide)');
        if (first && gallery.setActiveMedia) gallery.setActiveMedia(first.dataset.mediaId, false);
      }
      var viewer = gallery.querySelector('[id^="GalleryViewer"]');
      var thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
      if (viewer && viewer.resetPages) viewer.resetPages();
      if (thumbs && thumbs.resetPages) thumbs.resetPages();
    }

    apply();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(apply, 0); });
    }
  }

  var booted = false;
  function boot() {
    if (booted) return;
    var el = document.querySelector('script[id^="EurekaMediaData-"]');
    if (el) { booted = true; init(el); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('load', boot);
})();
